import { DiscussionContext } from "@cnx/common";
import { Box, Collapse, Flex } from "@mantine/core";
import { IconChevronDown, IconChevronUp } from "@tabler/icons-react";
import clsx from "clsx";
import { useState } from "react";
import ChatContextDropdownContent from "./ChatContextDropdownContent";
import ChatPopoverHeading from "./ChatPopoverHeading";

const ChatContextPopover = ({
  discussionContext,
}: {
  discussionContext: DiscussionContext;
}) => {
  const [opened, setOpened] = useState(false);

  const { activityKind, time, tripId, bookingId } = discussionContext || {};

  if (!discussionContext) {
    return <Box></Box>;
  }

  return (
    <Box className="w-full">
      <Box
        component="button"
        type="button"
        aria-expanded={opened}
        onClick={() => setOpened(o => !o)}
        className={clsx("w-full h-[58px] bg-gray-dark cursor-pointer", {
          "rounded-t-lg": opened,
          "rounded-lg": !opened,
        })}
      >
        <Box className="flex items-center px-4 w-full">
          <ChatPopoverHeading
            activityKind={activityKind}
            bookingId={bookingId}
            time={time}
            tripId={tripId}
          />
          <Box className="ml-auto shrink-0">
            {opened ? (
              <IconChevronUp color="white" size={24} />
            ) : (
              <IconChevronDown color="white" size={24} />
            )}
          </Box>
        </Box>
      </Box>
      <Collapse expanded={opened}>
        <Box className={"bg-gray-dark py-2.5 px-4 rounded-b-lg"}>
          <Flex
            direction="column"
            justify="left"
            gap="10px"
            className="text-white"
          >
            <ChatContextDropdownContent discussionContext={discussionContext} />
          </Flex>
        </Box>
      </Collapse>
    </Box>
  );
};

export default ChatContextPopover;
